import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTopSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronTopSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M12.3536 11.0605C12.1583 10.8652 11.8417 10.8652 11.6464 11.0605L8.35355 14.3534C8.15829 14.5487 7.84171 14.5487 7.64645 14.3534C7.45118 14.1581 7.45118 13.8416 7.64645 13.6463L10.9393 10.3534C11.5251 9.76762 12.4749 9.76762 13.0607 10.3534L16.3536 13.6463C16.5488 13.8416 16.5488 14.1581 16.3536 14.3534C16.1583 14.5487 15.8417 14.5487 15.6464 14.3534L12.3536 11.0605Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTopSmall;
